import type {PermissionsRecordType} from '../permissions';

export const interestPermissions = {
  interestRead: {
    actionId: 'READ',
    resourceId: 'INTEREST',
    scopes: ['PARTICIPATION', 'BRANCH'],
  },
  interestCreate: {
    actionId: 'CREATE',
    resourceId: 'INTEREST',
    scopes: ['PARTICIPATION', 'BRANCH'],
  },
  deleteInterest: {
    actionId: 'DELETE',
    resourceId: 'INTEREST',
    scopes: ['PARTICIPATION', 'BRANCH'],
  },
  interestTagRead: {
    actionId: 'RECORD_TAG_VALUES_READ_RECORD_TAG_VALUES',
    resourceId: 'INTEREST',
    scopes: ['PARTICIPATION', 'BRANCH'],
  },
  interestTagAddToRecord: {
    actionId: 'RECORD_TAG_VALUES_ADD_TAG_VALUE_TO_RECORD',
    resourceId: 'INTEREST',
    scopes: ['PARTICIPATION', 'BRANCH'],
  },
  interestTagRemoveFromRecord: {
    actionId: 'RECORD_TAG_VALUES_REMOVE_TAG_VALUE_FROM_RECORD',
    resourceId: 'INTEREST',
    scopes: ['PARTICIPATION', 'BRANCH'],
  },
  interestTagAdd: {
    actionId: 'ADD_TAG_VALUE',
    resourceId: 'INTEREST_TAG',
    scopes: [],
  },
  interestCustomFields: {
    actionId: 'CUSTOM_FIELDS_PAYLOAD_UPDATE',
    resourceId: 'INTEREST',
    scopes: ['BRANCH', 'PARTICIPATION'],
  },
  interestTagUpdate: {
    actionId: 'UPDATE_TAG_VALUE',
    resourceId: 'INTEREST_TAG',
    scopes: [],
  },
  interestTagRemove: {
    actionId: 'REMOVE_TAG_VALUE',
    resourceId: 'INTEREST_TAG',
    scopes: [],
  },
  interestTagClearExpiration: {
    actionId: 'CLEAR_TAG_VALUE_EXPIRATION',
    resourceId: 'INTEREST_TAG',
    scopes: [],
  },
  interestTagSetExpiration: {
    actionId: 'SET_TAG_VALUE_EXPIRATION',
    resourceId: 'INTEREST_TAG',
    scopes: [],
  },
  // ACL_EDIT_INTEREST
  interestChangeCustomer: {
    actionId: 'CHANGE_CUSTOMER',
    resourceId: 'INTEREST',
    scopes: ['PARTICIPATION', 'BRANCH'],
  },
  interestSelectContactPerson: {
    actionId: 'SELECT_CONTACT_PERSON',
    resourceId: 'INTEREST',
    scopes: ['PARTICIPATION', 'BRANCH'],
  },
  interestOpen: {
    actionId: 'OPEN',
    resourceId: 'INTEREST',
    scopes: ['PARTICIPATION', 'BRANCH'],
  },
  interestEnd: {
    actionId: 'END',
    resourceId: 'INTEREST',
    scopes: ['PARTICIPATION', 'BRANCH'],
  },
  interestReopen: {
    actionId: 'REOPEN',
    resourceId: 'INTEREST',
    scopes: ['PARTICIPATION', 'BRANCH'],
  },
  interestChangeMinisalePriceOffered: {
    actionId: 'CHANGE_MINISALE_PRICE_OFFERED',
    resourceId: 'INTEREST',
    scopes: ['PARTICIPATION', 'BRANCH'],
  },
  interestChangeLeadQuality: {
    actionId: 'CHANGE_LEAD_QUALITY',
    resourceId: 'INTEREST',
    scopes: ['PARTICIPATION', 'BRANCH'],
  },
  interestConvertToBusinessCase: {
    actionId: 'CONVERT_TO_BUSINESS_CASE',
    resourceId: 'INTEREST',
    scopes: ['PARTICIPATION', 'BRANCH'],
  },
  interestAddMinipurchaseOfferedVehicle: {
    actionId: 'ADD_MINIPURCHASE_OFFERED_VEHICLE',
    resourceId: 'INTEREST',
    scopes: ['PARTICIPATION', 'BRANCH'],
  },
  interestRemoveMinipurchaseOfferedVehicle: {
    actionId: 'REMOVE_MINIPURCHASE_OFFERED_VEHICLE',
    resourceId: 'INTEREST',
    scopes: ['PARTICIPATION', 'BRANCH'],
  },
  interestDismissVehicleRecommendations: {
    actionId: 'DISMISS_VEHICLE_RECOMMENDATIONS',
    resourceId: 'INTEREST',
    scopes: ['PARTICIPATION', 'BRANCH'],
  },
  // end of ACL_EDIT_INTEREST
} satisfies PermissionsRecordType;
